/**
 * Pad a 'number' with leading zeros (0), resulting a number with at leat the same amount of characters as the 'length' param
 *
 * @param (int) number   Number to be padded
 * @param (int) length   Total of characters thestring must have at least
 *
 * @return (string)
 */
window.padNumber = function(number, length) {
    var str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
};

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: sections interval
 * @param mixed   c: decimal delimiter
 * @param mixed   s: sections delimiter
 */
Number.prototype.format = function(n, x, c, s) {
    /* jslint bitwise: true */
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));
    /* jslint bitwise: false */
    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

window.formatMoney = function(amount, currency, locale) {
    amount = parseFloat(amount || 0);
    currency = currency || window.currency || 'CAD';
    locale = locale || window.env.language || 'en';
    var sign = amount < 0 ? '-' : '';
    amount = Math.abs(amount);
    if (locale === 'fr') {
        return sign + amount.format(2, 3, ',', ' ') + ' $';
    }
    return sign + '$' + amount.format(2, 3, '.', ',');
};

window.getCurrencyFlag = function(currency) {
    var flags = {
        USD: 'icon-flag-usa.png',
        CAD: 'icon-flag-canada.png',
        EUR: 'icon-flag-euro.png',
        GBP: 'icon-flag-pound.png',
    };
    return window.env.baseAssetUri + 'images/' + flags[currency.toUpperCase()];
};

window.debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};